import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Roles } from '@shared/models/types';
import { UserFilterURL, UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AdminService extends UserService {
  constructor(activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  override set filters(value: UserFilterURL) {
    const adminFilters = { ...value, role: Roles.ADMIN };
    super.filters = adminFilters;
  }

  initializeAdmins() {
    this.filters = { role: Roles.ADMIN };
  }
}
